import React from 'react'
import { sortCaret } from "../../../../comum/components/Icones";
import { situacaoFormatter, formatarReal, formatarDataCustomHTMLSemHora, situacaoOrcamentoFormatter } from "../../../../../utils/formatar";
import { observable, toJS } from "mobx";
import OrcamentoImportService from "../../../../../services/OrcamentoImportService";
import { buscaFiltrarVazio } from "../../../../../utils/mensagens";
import { urlApi } from '../../../../../config/Constantes';
import moment from "moment";


export default class OrcamentoImportStore {

    @observable dadosProcessoExpandir;
    @observable resultadoPesquisaExpandir;
    
    @observable modalRetirada;
    @observable modalCalcular;
    @observable dataDIObrigatorio;
    @observable modalPagamento;

    @observable modalPagamentoPix;
    @observable tipoPagamento;
    @observable dataPix;
    @observable totalPagamento;

    @observable listaSelecionados;
    @observable tabelaDados;
    @observable itens;
    @observable hasMore;

    @observable filtrado;
    @observable loading;
    @observable tableMessage;

    @observable numBl;
    @observable dataFimServ;
    @observable mensagem;

    @observable mensagemCif;
    @observable valorCif;
    @observable sucessoCif;
    @observable naoGeraBoleto;
    @observable totalFaturar;
    @observable listaServicos;
    @observable listaNaoSelecionaveis;
    @observable listaDetalhesServico;
    @observable listaDetalhesServicoRecalculo;
    @observable listaDetalhesServicoSelecionados;

    @observable modalArmazenamento;
    @observable loadingDadosArmazenagem;
    @observable dadosArmazem;
    @observable container;
    @observable guid;
    @observable loadingExibirOS;

    @observable loadingCalcular;
    @observable loadingCif;
    @observable loadingDemonstrativo;
    @observable loadingBoleto;

    @observable campoIncluiDataRetirada;
    @observable campoDiaPorta;
    @observable campoDesovaHouse;
    @observable campoRetiradaBarcaca;

    @observable dataRetirada;

    @observable blDiInfo;

    @observable colunas;

    @observable alerta;

    @observable modalTempSSA;

    constructor() {
        
        this.dadosProcessoExpandir = true;
        this.resultadoPesquisaExpandir = true;
        this.modalRetirada = false;
        this.modalCalcular = false;
        this.dataDIObrigatorio = false;
        this.modalPagamento = false;

        this.modalPagamentoPix = false;
        this.tipoPagamento = 0;
        this.dataPix = {};

        this.listaSelecionados = [];
        this.tabelaDados = [];
        this.listaServicos = [];
        this.listaDetalhesServico = [];
        this.listaDetalhesServicoRecalculo = [];
        this.listaDetalhesServicoSelecionados=[];
        this.listaNaoSelecionaveis = [];

        this.blDiInfo = null;
        
        this.filtrado = false;
        this.loading = false;
        this.tableMessage = buscaFiltrarVazio;
        this.totalFaturar = 0;

        this.itens = [];
        this.toShow = 20;
        this.turn = 0;
        this.hasMore = false;

        this.alerta = "";
        this.modalTempSSA = !process.env.rig;
        // Filtros de orçamento importação

        this.numBl = "";
        this.dataFimServ = null;

        this.mensagemCif = "";
        this.valorCif = null;
        this.sucessoCif = false;
        this.naoGeraBoleto = false;
        this.guid = null;
        this.loadingExibirOS = false;

        this.dataRetirada = moment().add(1,'day');

        //Campos

        this.campoIncluiDataRetirada = false;
        this.campoDiaPorta = false;
        this.campoDesovaHouse = false;
        this.campoRetiradaBarcaca = false;

        // Fim de filtros

        this.modalArmazenamento = false;
        this.loadingDadosArmazenagem = false;
        this.dadosArmazem = null;

        this.loadingBoleto = false;

        this.blDiInfo = null;
        this.container = null;

        this.loadingCalcular = false;
        this.loadingCif = false;
        this.loadingDemonstrativo = false;

        this.colunas = this.todasColunas;

        this.download = document.createElement('a')
        document.body.appendChild(this.download)
        this.download.style = "display: none"
        this.download.target = "_blank"
        this.mensagem = "";

        this.service = new OrcamentoImportService();
    }

    Pesquisar = () => {
        this.filtrado = true;
        this.loading = true;
        this.tableMessage = "";
        this.tabelaDados = [];
        if(process.env.rig) {
            let cifFinal;
            if(this.sucessoCif) {
                cifFinal = this.valorCif;
            } else {
                cifFinal = this.valorCif ? this.valorCif.replace("R$","").replace(/\./g,"").replace(",",".") : this.valorCif;
            }
            this.service.PesquisaRig(this.numBl, cifFinal, this.campoDiaPorta, this.campoIncluiDataRetirada, this.dataRetirada && moment(this.dataRetirada).format('YYYY-MM-DD'), this.campoDesovaHouse, this.campoRetiradaBarcaca).then(response => {
                if(response && response.data) {
                    if(response.data.Mensagem) {
                        this.alerta = response.data.Mensagem
                    }else if(response.data.PrestadorList) {
                        this.tabelaDados = response.data.PrestadorList;
                        this.listaServicos = response.data.PrestadorList.reduce((todos, servico) => todos.concat(servico.Servicos), []);
                        this.listaNaoSelecionaveis = this.listaServicos.filter(servico => !servico.HabilitarPagamento).map(s => s.OsId);
                        this.listaSelecionados = this.listaServicos.filter(servico => servico.Pagar);
                        const faturar = this.tabelaDados.map(value => value.TotalPagar);
                        this.totalFaturar = faturar.reduce((total, value) => total + value);
                        //this.tabelaDados.forEach(dado => dado.Servicos.forEach(servico => servico.selecionado = false));
                    }
                    if(response.data.BlDiGeral !== null) this.blDiInfo = response.data.BlDiGeral;
                    if(this.tabelaDados !== null) this.itens = this.tabelaDados;
                    
                    if(this.blDiInfo === null && this.listaDetalhesServico === null) this.tableMessage = "Não foram encontrados dados."
                }
                
                //this.loadFirstTurn();
            }).catch(err => console.error(err)
            ).finally(() => { this.loading = false; });
        } else {
            this.service.PesquisaSsa(this.numBl).then(response => {
                if(response && response.data) {
                    if(response.data.Mensagem) this.alerta = response.data.Mensagem;
                
                    this.naoGeraBoleto = false;
                    this.blDiInfo = response.data.BlDiGeral;
                    this.listaDetalhesServico = response.data.FatWebOsList;
                    this.listaDetalhesServicoRecalculo = this.listaDetalhesServico
                    this.listaDetalhesServico !== null && this.listaDetalhesServico.forEach(servico => servico.selecionado = false);

                    if(this.blDiInfo && this.blDiInfo.ValorReal === null) this.naoGeraBoleto = true;


                    if(this.blDiInfo === null && this.listaDetalhesServico === null) this.tableMessage = "Não foram encontrados dados."
                }
                
                //this.loadFirstTurn();
            }).catch(err => console.error(err)
            ).finally(() => { this.loading = false; });
        }
    }

    loadFirstTurn = () => {
        this.itens = this.tabelaDados.slice(0, this.toShow)
        this.turn = 1
        this.hasMore = this.itens.length < this.tabelaDados.length
    }

    loadNextTurn = () => {
        this.itens = []
        this.itens = this.tabelaDados.slice(0, (this.turn+1)*this.toShow)
        this.turn = this.turn+1

        this.hasMore = this.itens.length < this.tabelaDados.length
    }

    verificarValorCif = () => {
        this.loadingCif = true;
        this.naoGeraBoleto = false;
        this.service.RecuperarCif(this.numBl).then(response => {
            if(response && response.data) {
                this.mensagemCif = response.data.Mensagem;
                this.valorCif = response.data.ValorCifReal;
                this.sucessoCif = response.data.Sucesso;
                this.naoGeraBoleto = !response.data.Sucesso;
            }
        }).catch(err => console.error(err)
        ).finally(() => {this.loadingCif = false});
    }

    //Para uso de SSA
    gerarListaServicos = () => {
        return this.listaDetalhesServico.map(servico => ({DscTipoServico: servico.DscTipoServico,CdTipoServico: servico.CdTipoServico, selecionado: servico.selecionado}))
    }

    fecharModalMensagem = () => {
        this.mensagem = ""
    }

    calcular = (dataFim="", docDi="", moeda="", valorCif="") => {
        this.valorCif = parseFloat(valorCif);


        this.listaDetalhesServicoSelecionados = this.listaDetalhesServicoRecalculo.filter(i => i.selecionado === true);

        this.loadingCalcular = true;

        const servicosSelecionados = this.listaDetalhesServicoSelecionados.map(servico => servico.CdTipoServico);
        
        this.service.Calcular(dataFim, this.blDiInfo.BlId, docDi, moeda, this.valorCif, this.gerarListaServicosCalculo()).then(response => {
            if(response && response.data && response.data.Sucesso) {
                //this.tabelaDados = response.data;
                this.dataFimServ = response.data.DataFimServ;
                this.guid = response.data.Guid;
                if(response.data.FatWebOsList) {
                    // Eu tenho de mapear os dados que vem já que o serviço não trás os mesmos nomes que anteriormente usados pela tabela
                    this.listaDetalhesServico = this.listaDetalhesServico.filter(servico => !(servicosSelecionados.includes(servico.CdTipoServico)));
                    this.listaDetalhesServico = [...response.data.FatWebOsList.map(fatWeb => ({
                        DscTipoServico: fatWeb.DscTipoServico,
                        Quant:fatWeb.Quant,
                        ValorTotal:fatWeb.ValorTotal,
                        selecionado: true
                    })), ...this.listaDetalhesServico];

                    this.listaDetalhesServicoSelecionados = this.listaDetalhesServico.filter(servico => servico.selecionado);
                    console.log(this.listaDetalhesServico);
                    console.log(this.listaDetalhesServicoSelecionados);
                    if(this.guid) {
                        this.loadingExibirOS = true;
                        
                        this.ExibirOS().finally(() => {this.loadingExibirOS = false; if(!this.loadingCalcular) this.fecharModalCalculo();});
                    }
                }
            } else {
                this.dataFimServ = null;
                this.alerta = "Não possível realizar o cálculo. Por favor, entre em contato com o GAC.";
            }
        }).catch(err => console.error(err)
        ).finally(() => {
            if(!this.loadingExibirOS) this.fecharModalCalculo();
            this.loadingCalcular = false;
        });
    }

    gerarListaServicosCalculo = () => {
        return ({
            "ListaTipoServ": this.listaDetalhesServicoSelecionados.map(servico => ({DscTipoServico: servico.DscTipoServico, CdTipoServico: servico.CdTipoServico}))
        });
    }

    ExibirOS = (tipo) => {
        return this.service.ExibirOs(this.guid, (this.dataFimServ !== null && this.dataFimServ !== undefined) ? this.dataFimServ : "").then(response => {
                if(response && response.data) {
                    this.tabelaDados = response.data.PrestadorList;
                    this.listaServicos = response.data.PrestadorList.reduce((todos, servico) => todos.concat(servico.Servicos), []);
                    this.listaNaoSelecionaveis = this.listaServicos.filter(servico => (tipo != undefined) ? servico.HabilitarPagamento : tipo ).map(s => s.OsId);
                    this.listaSelecionados = this.listaServicos.filter(servico => (tipo != undefined) ? tipo : servico.Pagar);
                    const faturar = this.tabelaDados.map(value => value.TotalPagar);
                    this.totalFaturar = faturar.reduce((total, value) => total + value);
                }
            }).catch(err => console.err(err))
    }

    getArmazenagem = (id) => {
        this.loadingDadosArmazenagem = true;
        if(id === null) {
            this.alerta = "Esta OS não possui detalhamento de armazenagem - Valor R$0."
            this.loadingDadosArmazenagem = false;
            return;
        }
        this.service.DemonstrativoArmazenagem(id).then(response => {
            if(response && response.data) {
                this.dadosArmazem = response.data
            }
        }).catch(err => console.log(err)
        ).finally(() => {this.loadingDadosArmazenagem = false;});
    }

    listaDadosBoleto = () => {
        let prestadorBoleto = toJS(this.tabelaDados);
        const selecionados = this.listaSelecionados.map(selecionado => selecionado.OsId);
        prestadorBoleto.forEach(prestador => {
            prestador.Servicos.forEach(servico => {
                selecionados.includes(servico.OsId) ? servico.Pagar = true : servico.Pagar = false
            });
            prestador.Servicos = prestador.Servicos.filter(s => s.Pagar); //S de serviço
        });
        prestadorBoleto = prestadorBoleto.filter(p => p.Servicos.length > 0); //P de prestador
        //prestadorBoleto.forEach(prestador => prestador.Servicos.forEach(servico => delete servico.selecionado));
        return prestadorBoleto;
    }

    gerarPix = () => {
        this.loadingBoleto = true;
        const prestadorBoleto = this.listaDadosBoleto();
        this.totalPagamento = prestadorBoleto.reduce((acc, bol)=> {return acc + bol.Servicos.reduce((a,serv)=> {return a + (serv.ValorPagar - serv.ValorImpostos)},0)},0)
        if(process.env.rig) {
            this.service.GerarPixRig(
                this.numBl,
                this.valorCif,
                this.campoDiaPorta,
                this.campoIncluiDataRetirada,
                this.dataRetirada,
                this.campoDesovaHouse,
                this.campoRetiradaBarcaca,
                this.refCliente,
                prestadorBoleto
            ).then(res => {
                if(res && res.data) {
                    if (res.data.Sucesso){
                        this.dataPix = res.data;
                        this.modalPagamentoPix = true; 
                    } else {
                        this.alerta = res.data.Mensagem
                    }
                } else {
                    this.alerta = "Ocorreu um erro inesperado.";
                }
            })
            .catch(err => console.log(err))
            .finally(()=>{
                this.loadingBoleto = false;
                this.fecharModalPagamento();
                this.Pesquisar();            
            });            
        }else {
            this.service.GerarPixSsa(this.guid, moment().format("YYYY-MM-DD"), false, false, this.numBl, "", this.refCliente, prestadorBoleto).then(res => {
                // if(res.status !== 200) {
                //     this.alerta = res.data;
                // } 
                 if(res && res.data.Sucesso) {
                    this.dataPix = res.data;
                    this.modalPagamentoPix = true; 
                }
                else {
                    this.alerta = res.data.Mensagem;
                     }
            })
            .catch(err => { console.log(err) })
            .finally(()=>{
                this.ExibirOS(false).finally(() => {
                    this.loadingBoleto = false;
                    this.fecharModalPagamento()                    
                })               
            });            
        }
    }

    gerarBoleto = () => {
        this.loadingBoleto = true;
        const prestadorBoleto = this.listaDadosBoleto();

        if (process.env.rig) {
            this.service.GerarBoletoRig(
                this.numBl,
                this.valorCif,
                this.campoDiaPorta,
                this.campoIncluiDataRetirada,
                this.dataRetirada,
                this.campoDesovaHouse,
                this.campoRetiradaBarcaca,
                this.refCliente,
                prestadorBoleto
            ).then(response => {
                if (response.status !== 200) {
                    this.alerta = response.data;
                } else if (response && response.data) {
                    this.abrirBoleto(response.data);
                }
            }).catch(err => {
                console.error(err);
            }).finally(() => {
                this.loadingBoleto = false;
                this.fecharModalPagamento();
                this.Pesquisar();
            });

        } else {
            this.service.GerarBoletoSsa(
                this.guid,
                moment().format("YYYY-MM-DD"),
                false,
                false,
                this.numBl,
                "",
                this.refCliente,
                prestadorBoleto
            ).then(response => {
                if (response.status !== 200) {
                    this.alerta = response.data;
                } else if (response && response.data) {
                    this.abrirBoleto(response.data);
                }
            }).catch(err => {
                console.error(err);
            }).finally(() => {
                this.ExibirOS().finally(() => {
                    this.loadingBoleto = false;
                    this.fecharModalPagamento();
                });
            });
        }
    };

    base64ToPdfBlob = (base64) => {
        const byteCharacters = atob(base64);
        const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: 'application/pdf' });
    };

    abrirBoleto = (base64) => {
        const blob = this.base64ToPdfBlob(base64, "application/pdf");
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
    };

    gerarDemonstrativo = () => {
        this.loadingDemonstrativo = true;
        let dtFim =this.dataFimServ;
        let NBl = this.blDiInfo.NumeroBl;
        let guid = this.guid;
        let valorCif = this.valorCif;
        if (NBl && dtFim)
        {
            this.service.GerarDemonstrativo(this.blDiInfo.NumeroBl, this.dataFimServ, valorCif, guid)
            .then(r =>{
                if(r.status !== 200) {
                    if(r.status === 404) {
                        this.mensagem = "Nada foi encontrado. Código 404.";
                    } else {
                        this.mensagem = r.data;
                    }
                }
                else 
                {
                    const file = new Blob([r.data], { type: "application/pdf"});
                    const url = window.URL.createObjectURL(file)
                    this.download.href = url
                    this.download.click()
                }
            }).catch(err => console.log(err)
            ).finally(() => {this.loadingDemonstrativo = false});
        }
    }

    selecionar = (row) => {
        row.Pagar = !row.Pagar;

        this.listaServicos.forEach(servico => {
            if(row.OsId === servico.OsId) {
                servico.Pagar = row.Pagar;
            }
        });

        this.listaSelecionados = this.listaServicos.filter(i => i.Pagar === true);
    }

    selecionarTodos = (rows, checked) => {
        rows.forEach(item => {
            if(item.HabilitarPagamento){
                item.Pagar = checked
            }
        });

        this.listaServicos.forEach(servico => {
            rows.forEach(row => {
                if(row.OsId === servico.OsId) {
                    servico.Pagar = row.Pagar;
                }
            });
        });

    this.listaSelecionados = this.listaServicos.filter(i => i.Pagar === true)
    }

    toggleDadosProcesso = () => {
        this.dadosProcessoExpandir = !this.dadosProcessoExpandir;
    }
    
    toggleResultadoPesquisa = () => {
        this.resultadoPesquisaExpandir = !this.resultadoPesquisaExpandir;
    }

    fecharModalAviso = () => {
        this.alerta = ""
    }

    abrirModalRetirada = () => {
        this.modalRetirada = true;
    }

    fecharModalRetirada = () => {
        this.modalRetirada = false;
    }

    abrirModalCalculo = () => {
        this.modalCalcular = true;        
    }

    fecharModalCalculo = () => {
        this.modalCalcular = false;
        this.setDIObrigatorio(false);
    }

    abrirModalPagamento = () => {
        this.modalPagamento = true;
    }

    fecharModalPagamento = () => {
        this.modalPagamento = false;
    }

    abrirModalPagamentoPix = () => {
        this.modalPagamentoPix = true;
    }

    fecharModalPagamentoPix = () => {
        this.modalPagamentoPix = false;
    }

    abrirModalArmazenamento = (id) => {
        this.getArmazenagem(id)
        if(id !== null) {
            this.modalArmazenamento = true;
        }
    }

    fecharModalArmazenamento = () => {
        this.dadosArmazem = null;
        this.modalArmazenamento = false;
    }

    setNumBl = (value) => {
        this.numBl = value ? value.replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '') : value;

        this.valorCif = null;
        this.sucessoCif = false;

        if(value !== "" && process.env.rig) {
            this.verificarValorCif();
        }
    }

    setContainer = (value) => {
        this.container = value;
    }

    setValorCif = (value) => {
        this.valorCif = value;
    }
    
    setRefCliente = (value) => {
        this.refCliente = value;
    }

    setDIObrigatorio = (bool) => {
        this.dataDIObrigatorio = bool;
    }

    calculaTotal = () => {
        const totais = this.listaSelecionados.map(v => v.ValorPagar);
        const total = totais.length > 0 ? totais.reduce((t, value) => t + value) : 0;
        return total.toLocaleString('pt-BR',{style: 'currency', currency: 'BRL', minimumFractionDigits: 2});
    }

    getTotalDemonstrativo = (param) => {
        //Assim, eu posso adicionar qualquer verificação de uma só vez
        if(!this.dadosArmazem.ArmCalcItemList) return null;
        const totais = this.dadosArmazem.ArmCalcItemList.map(v => v[param])
        let total = totais.reduce((total, item) => total + item);
        if(total === null) total = 0;
        return total.toLocaleString('pt-BR',{style:'currency', currency:'BRL', minimumFractionDigits:2});
    }

    setDataRetirada = (value) => {
        this.dataRetirada = moment(value).format("YYYY-MM-DD");
    }

    setCampoPreferencia = (campo, value) => {
        switch(campo) {
            case 'incluiData':
                this.campoIncluiDataRetirada = value;
            break;
            case 'diaPorta':
                this.campoDiaPorta = value;
            break;
            case 'desovaHouse':
                this.campoDesovaHouse = value;
            break;
            case 'retiradaBarcaca':
                this.campoRetiradaBarcaca = value;
            break;
            default:
                null;

        }
    }

    formatArmz = (cell, row) => {
        return (
            <button className="btn-primary mx-0" onClick={() => this.abrirModalArmazenamento(row.FatCalculoPrecoOS.ArmCalcId)}>
                {cell}
            </button>
        )
    }

    selecionarDetalhesServico = (row) => {
        row.selecionado = !row.selecionado;

        this.listaDetalhesServicoSelecionados = this.listaDetalhesServico.filter(i => i.selecionado === true);

    }

    selecionarTodosDetalhesServico = (rows, checked) => {

        console.log(checked);
        rows.forEach(row => {
            row.selecionado = checked;
        })

        this.listaDetalhesServico.forEach(servico => {
            rows.forEach(row => {
                if(row.CdTipoServico === servico.CdTipoServico) {
                    servico.selecionado = checked;
                }
            })
        });

        this.listaDetalhesServicoSelecionados = this.listaDetalhesServico.filter(i => i.selecionado === true);
        console.log(this.listaDetalhesServicoSelecionados);
    }

    todasColunas = [
        {
            text:"OS",
            dataField:"OsId",
            sort: true,
            headerAlign: 'left',
            align: 'left',
            sortCaret: sortCaret
        },
        {
            text:"Serviço",
            dataField:"DscTipoServico",
            sort: true,
            headerAlign: 'left',
            formatter: (cell, row) => row.FlagArmz === "V" ? this.formatArmz(cell, row) : cell, 
            align: 'left',
            sortCaret: sortCaret
        },
        {
            text:"Cntr",
            dataField:"CodCntr",
            sort: true,
            headerAlign: 'left',
            align: 'left',
            sortCaret: sortCaret
        },
        {
            text:"Unitário",
            dataField:"FatCalculoPrecoOS.Valor",
            sort: true,
            headerAlign: 'left',
            formatter: formatarReal,
            align: 'left',
            sortCaret: sortCaret
        },
        {
            text:"QTD",
            dataField:"Qtd",
            sort: true,
            headerAlign: 'left',
            align: 'left',
            sortCaret: sortCaret
        },
        {
            text:"Total",
            dataField:"ValorTotal",
            sort: true,
            headerAlign: 'left',
            formatter: formatarReal,
            align: 'left',
            sortCaret: sortCaret
        },
        {
            text:"Faturado",
            dataField:"ValorPago",
            sort: true,
            headerAlign: 'left',
            formatter: formatarReal,
            align: 'left',
            sortCaret: sortCaret
        },
        {
            text:"A faturar",
            dataField:"ValorPagar",
            sort: true,
            headerAlign: 'left',
            formatter: formatarReal,
            align: 'left',
            sortCaret: sortCaret
        },
        {
            text:"Situação",
            dataField:"Legenda",
            sort: true,
            headerAlign: 'center',
            align: 'center',
            formatter: (cell, row) => cell ? situacaoOrcamentoFormatter(cell, row) : '---',
            sortCaret: sortCaret
        }
    ]

    colunasDetalhesServico = [
        {
            text:"Serviço",
            dataField:"DscTipoServico",
            sort: true,
            headerAlign: 'left',
            align: 'left',
            sortCaret: sortCaret
        },{
            text:"Qtd",
            dataField:"Quant",
            sort: true,
            headerAlign: 'left',
            align: 'left',
            sortCaret: sortCaret
        },{
            text:"Valor total",
            dataField:"ValorTotal",
            sort: true,
            headerAlign: 'left',
            formatter: formatarReal,
            align: 'left',
            sortCaret: sortCaret
        },
    ]

    colunasDetalhesArmazenagem = [
        {
            text:"Período",
            dataField:"Periodo",
            sort: true,
            headerAlign: 'left',
            align: 'left',
            sortCaret: sortCaret
        },
        {
            text:"Início",
            dataField:"DataIni",
            sort: true,
            headerAlign: 'left',
            align: 'left',
            formatter: formatarDataCustomHTMLSemHora,
            sortCaret: sortCaret
        },
        {
            text:"Fim",
            dataField:"DataFim",
            sort: true,
            headerAlign: 'left',
            align: 'left',
            formatter: formatarDataCustomHTMLSemHora,
            sortCaret: sortCaret
        },
        {
            text:"Dias",
            dataField:"Dias",
            sort: true,
            headerAlign: 'left',
            align: 'left',
            sortCaret: sortCaret
        },
        {
            text:"Calculado",
            dataField:"ValorCalculado",
            sort: true,
            headerAlign: 'left',
            formatter: formatarReal,
            align: 'left',
            sortCaret: sortCaret
        },
        {
            text:"Valor final",
            dataField:"ValorFinalCalculado",
            sort: true,
            headerAlign: 'left',
            formatter: formatarReal,
            align: 'left',
            sortCaret: sortCaret
        },
        {
            text:"Adicionais",
            dataField:"ValorAdicional",
            sort: true,
            headerAlign: 'left',
            formatter: formatarReal,
            align: 'left',
            sortCaret: sortCaret
        },
    ]
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/importacao/stores/OrcamentoImportStore.js